import { Equipment } from "@/types/Equipment";
import baseGoApi from "@/api/baseGoApi.ts";

const EQUIPMENT_ENDPOINT = "/equipment";

/**
 * Fetch all equipment.
 * @returns Promise<Equipment[]>
 */
export const fetchAllEquipment = async (): Promise<Equipment[]> => {
    try {
        const response = await baseGoApi.get(EQUIPMENT_ENDPOINT);
        return response.data as Equipment[];
    } catch (error: any) {
        console.error("Error fetching equipment:", error);
        throw new Error("Failed to fetch equipment.");
    }
};

/**
 * Fetch a single equipment item by ID.
 * @param id Equipment ID
 * @returns Promise<Equipment>
 */
export const fetchEquipmentById = async (id: number): Promise<Equipment> => {
    try {
        const response = await baseGoApi.get(`${EQUIPMENT_ENDPOINT}/${id}`);
        return response.data as Equipment;
    } catch (error: any) {
        console.error(`Error fetching equipment with ID ${id}:`, error);
        throw new Error(`Failed to fetch equipment with ID ${id}.`);
    }
};

/**
 * Create a new equipment item.
 * @param equipmentData Data for the new equipment
 * @returns Promise<Equipment>
 */
export const createEquipment = async (equipmentData: Partial<Equipment>): Promise<Equipment> => {
    try {
        const response = await baseGoApi.post(EQUIPMENT_ENDPOINT + '/', equipmentData);
        return response.data as Equipment;
    } catch (error: any) {
        console.error("Error creating equipment:", error);
        throw new Error("Failed to create equipment.");
    }
};

/**
 * Update an existing equipment item.
 * @param id Equipment ID
 * @param equipmentData Updated equipment data
 * @returns Promise<Equipment>
 */
export const updateEquipment = async (id: number, equipmentData: Partial<Equipment>): Promise<Equipment> => {
    try {
        const response = await baseGoApi.put(`${EQUIPMENT_ENDPOINT}/${id}`, equipmentData);
        return response.data as Equipment;
    } catch (error: any) {
        console.error(`Error updating equipment with ID ${id}:`, error);
        throw new Error(`Failed to update equipment with ID ${id}.`);
    }
};

/**
 * Delete an equipment item by ID.
 * @param id Equipment ID
 * @returns Promise<void>
 */
export const deleteEquipment = async (id: number): Promise<void> => {
    try {
        await baseGoApi.delete(`${EQUIPMENT_ENDPOINT}/${id}`);
    } catch (error: any) {
        console.error(`Error deleting equipment with ID ${id}:`, error);
        throw new Error(`Failed to delete equipment with ID ${id}.`);
    }
};
